import React from 'react';

interface PrimaryButtonProps {
  text: string;
  containerStyle: React.CSSProperties;
  disabled: boolean;
  onClick: (() => void) | ((event: any) => void);
  invertedColors?: boolean;
  resetColors?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  text,
  containerStyle,
  disabled,
  onClick,
  invertedColors,
  resetColors,
}: PrimaryButtonProps) => {
  const styles = {
    container: {
      display: 'flex',
      alignItem: 'center',
      justifyContent: 'center',
      marginTop: 30,
    },
    button: {
      cursor: 'pointer',
      backgroundColor: !resetColors ? (invertedColors ? '#fff' : '#009dcc') : '#D1D1D3',
      padding: '0px 10px',
      border: 0,
      minWidth: 150,
      height: 64,
      borderRadius: 100,
      boxShadow: invertedColors ? '1px 17px 44px rgba(3, 2, 41, 0.07)' : '',
    } as React.CSSProperties,
    buttonDisabled: {
      backgroundColor: '#ededed',
      padding: '0px 10px',
      border: 0,
      margin: 20,
      minWidth: 150,
      height: 64,
      borderRadius: 100,
    },
    text: {
      color: invertedColors ? '#009dcc' : '#fff',
      fontWeight: 'normal',
      fontSize: 18,
      margin: 0,
    },
  };

  return (
    <div style={{ ...styles.container, ...containerStyle }}>
      <button
        disabled={disabled}
        style={disabled ? styles.buttonDisabled : styles.button}
        onClick={onClick}
      >
        <p style={styles.text}> {text}</p>
      </button>
    </div>
  );
};

export default PrimaryButton;
